import type { RouteRecordRaw } from 'vue-router'

import { MODELS_COMPARISON } from './routes-names'

export default (): RouteRecordRaw[] => {
  return [
    {
      path: '/:locale/compare',
      component: () =>
        import('@backmarket/nuxt-layer-base/components/RouteRecordWithChildrenOnly/RouteRecordWithChildrenOnly.vue'),
      meta: {
        cache: 'public, max-age=300',
      },
      children: [
        {
          name: MODELS_COMPARISON.HOME,
          path: 'home',
          component: () =>
            import('~/scopes/models-comparison/pages/Home/Home.vue'),
          meta: {
            owners: ['bot-squad-acquisition-front'],
          },
        },
        {
          name: MODELS_COMPARISON.CATEGORY,
          path: ':category',
          component: () =>
            import('~/scopes/models-comparison/pages/Search/Search.vue'),
          meta: {
            owners: ['bot-squad-acquisition-front'],
          },
        },
        {
          name: MODELS_COMPARISON.COMPARISON_RESULTS,
          path: ':productA/:productB',
          component: () =>
            import('~/scopes/models-comparison/pages/Results/Results.vue'),
          meta: {
            owners: ['bot-squad-acquisition-front'],
          },
        },
      ],
    },
  ]
}
